import {
  RobotFakeKnowledgeGraphMsg,
  KnowledgeGraphMsg,
  TextMessage,
} from "@/utils/message";
import "./index.less";

function CardKownledgeGraph(props) {
  const { msg, chatInstance } = props;
  const graphMsg = msg.graph;
  const onlyOneRoot = graphMsg.matchItems.length === 1; //就一个根节点，不展示

  let knowledgeList = graphMsg.matchItems.map((graphItem) => {
    return {
      isItem: false,
      itemName: graphItem.itemName,
      subitemNames: graphItem.subitemNames,
    };
  });

  if (onlyOneRoot) {
    knowledgeList = graphMsg.matchItems[0].subitemNames.map((graphItem) => {
      return {
        isItem: true,
        itemName: graphItem,
        subitemNames: [],
      };
    });
  }

  const handleItemClick = (message, index) => {
    if (message.subitemNames.length === 0) {
      const queryMsg = KnowledgeGraphMsg({
        displayMsg: message.itemName,
        trueQueryMsg: message.isItem
          ? `<chatqa-subitemname>${message.itemName}</chatqa-subitemname>`
          : `<chatqa-itemname>${message.itemName}</chatqa-itemname>`,
        queryPath: msg.s_Path
          ? msg.s_Path + "/" + graphMsg.matchItems?.[index]?.itemName
          : graphMsg.matchItems?.[0]?.itemName,
      });
      chatInstance.ctx?.postMessage?.(queryMsg);
    } else if (onlyOneRoot) {
      const queryMsg = KnowledgeGraphMsg({
        displayMsg: message.itemName,
        trueQueryMsg: `<chatqa-itemname>${graphMsg.matchItems[0].itemName}</chatqa-itemname><chatqa-subitemname>${message.itemName}</chatqa-subitemname>`,
        queryPath: msg.s_Path
          ? msg.s_Path + "/" + graphMsg.matchItems[0].itemName
          : graphMsg.matchItems[0].itemName,
      });
      chatInstance?.ctx?.postMessage?.(queryMsg);
    } else if (message.itemName && message.subitemNames.length === 1) {
      const txt = message.subitemNames.filter((item, index) => index === 0)[0];
      const msg = TextMessage(txt, "left");
      chatInstance?.ctx?.appendMessage?.(msg);
    } else {
      const msg = RobotFakeKnowledgeGraphMsg(
        message.itemName,
        message.subitemNames
      );
      chatInstance?.ctx?.appendMessage?.(msg);
    }
  };

  const queryElements = knowledgeList.map(
    (msg, index) => {
      return (
        <button
          className="card_knowledge__item"
          onClick={() => handleItemClick(msg, index)}
          key={index}
        >
          {msg.itemName}
        </button>
      );
    }
  );

  // 如果只有一条消息， 则直接发送第一个消息，不显示其他选项
  return (
    <div className="msg-line">
      <h4 className="card_title">
        小育根据已学知识为您找到 “{msg.graph.query}”，供您参考：
      </h4>
      <div className="card_knowledge">{queryElements}</div>
    </div>
  );
}

export default CardKownledgeGraph;
